<template>
    <div class="dat-wrapper">
        <depositRenderData
            :data="savingAccountData"
            :view-button-text="viewButtonText"
            :bank-health="bankHealth"
            :has-error="hasError"
        />
    </div>
</template>
<script>
    import depositRenderData from './deposit-render-data.vue';
    import depositPaymentHelper from '~/helpers/deposit-account-api';

    export default {
        components: {
            depositRenderData,
        },
        props: ['viewButtonText', 'bankHealth'],
        data() {
            return {
                savingAccountData: [],
                hasError: false,
            };
        },
        async mounted() {
            await depositPaymentHelper.depositAccountData('lt-rt-sav').then((response) => {
                if (response.status === true) {
                    this.savingAccountData = response.data;
                } else {
                    this.hasError = true;
                }
            });
        },
    };
</script>
